// The → DISCORD mark of the clan chat (player-reach.md §3.10, R1641).
//
// While the chat relay of the clan is on, the meta server copies each new
// line of the clan chat to a Discord channel, where people outside the
// clan can read it. Every member therefore sees one standing mark in the
// chat: a tag in the head of the CLAN CHAT card of the hub, and a line
// that stands at the top of the CLAN tab of the game chat. The title says
// the whole sentence on a pointer, and the CLAN tab line says it on a
// telephone, where nothing depends on hover (ui-map-interface.md §12).
//
// The flag comes off the chat socket alone (`net/clanchat.ts` onRelay):
// the welcome states it, and a `relay` frame states a change.

import { relayMark as S } from '../gen/strings';
import { esc } from './esc';

/** The line that stands at the top of the CLAN tab of the game chat. */
export function relayMarkLine(): string {
  return `<div class="line relaymark" title="${esc(S.title)}">${esc(S.line)}</div>`;
}
